export default "__VITE_PUBLIC_ASSET__86f066db__"